var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",style:({
    background: `url(${_vm.itemData.backgroundUrl}?x-oss-process=image/resize,w_750/quality,q_80) top center / 100% 100%`,
    padding: `${_vm.computedStyle(_vm.itemData.padding.top)}px ${_vm.computedStyle(
      _vm.itemData.padding.right
    )}px ${_vm.computedStyle(_vm.itemData.padding.bottom)}px ${_vm.computedStyle(
      _vm.itemData.padding.left
    )}px`,
  })},[_c('van-swipe',{staticClass:"banner-swipe",attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.itemData.banner.imgList),function(item,index){return _c('van-swipe-item',{key:index},[_c('van-image',{attrs:{"src":item + '?x-oss-process=image/resize,w_750/quality,q_80'}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }